"use client"

import { NpButton } from "src/components/np-design/components/button/NpButton"
import { ExperimentKey, experiments } from "src/integrations/posthog/experiments"
import { setLocalExperimentVariant, useExperimentVariant } from "src/integrations/posthog/useExperiment"

export type ExperimentVariantSwitcherProps = {
  experiment: ExperimentKey
  onClose?: () => void
}

export const ExperimentVariantSwitcher = ({ experiment, onClose }: ExperimentVariantSwitcherProps) => {
  const { variant: activeVariant } = useExperimentVariant(experiment)

  return (
    <div className="text-default flex flex-wrap items-center justify-center gap-2 rounded-xl border bg-white p-2">
      <h2 className="m-0 ml-2 text-base">{experiment}</h2>

      {experiments[experiment]?.map((variant) => (
        <NpButton
          key={variant}
          variant={variant === activeVariant ? "filled" : "outlined"}
          color="gray10"
          size="xs"
          onClick={() => setLocalExperimentVariant(experiment, variant)}
        >
          {variant}
        </NpButton>
      ))}

      <NpButton variant="ghost" color="red" size="xs" onClick={onClose} iconNameLeft="close" title="Verbergen" />
    </div>
  )
}
